import { Injectable } from '@angular/core';
import { UserDTO } from '@shared/dtos';
import { Firestore, addDoc, collection } from '@angular/fire/firestore';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { map, Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserServiceBackend {
    private readonly TABLE = "user";
    
    constructor(private firestore: Firestore, private angularFirestore: AngularFirestore) { }

    public getUser(idUser: string): Observable<UserDTO[]> {
        return this.angularFirestore.collection<UserDTO>(this.TABLE, ref => ref.where('idUser', '==', idUser))
        .snapshotChanges()
        .pipe(
            map(response => response.map(a => {
              const user = a.payload.doc.data() as UserDTO;
              const id = a.payload.doc.id;
              return new UserDTO(user.idUser, user.firstName, user.lastName, user.email, id);
            }))
        );
    }

    public saveUser(user: UserDTO) {
        const placeRef = collection(this.firestore, this.TABLE);
        return addDoc(placeRef, user.getJSON());
    }
}
